import { render, staticRenderFns } from "./LanguageToggle.vue?vue&type=template&id=4d57435a&scoped=true&"
import script from "./LanguageToggle.vue?vue&type=script&lang=ts&"
export * from "./LanguageToggle.vue?vue&type=script&lang=ts&"
import style0 from "./LanguageToggle.vue?vue&type=style&index=0&id=4d57435a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d57435a",
  null
  
)

export default component.exports